package one.healthium.login.ui.magic_link

sealed interface MagicLinkUiEvent {
    data object OnMagicLinkSent : MagicLinkUiEvent
}